




































































    // <rim-repair-modal-component :dialog="dialog" @close="goToLogin()">
    //   <div slot="component">
    //     <h3 class="mb-2">Your session has expired</h3>
    //     <v-divider class="mb-4"></v-divider>
    //     <v-row class="pa-0" justify="end">
    //       <v-btn color="primary" class="ma-2" @click="goToLogin()">Accept</v-btn>
    //     </v-row>
    //   </div>
    // </rim-repair-modal-component>

import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { ISnackbar, Callback, DialogConfig, BlockerConfig } from "./interfaces";
// import { RimRepairModalComponent } from "@/components/common";
import { UserInterface } from './utils/UserInterface';

@Component({
  components: {
    // RimRepairModalComponent,
  },
})
export default class AppComponent extends Vue {

	private UI__: UserInterface;

	mounted(){
		this.UI__ = new UserInterface(this);
	}


  @Getter("getSnackbarData", { namespace: "AppModule" })
  public snackbarData!: ISnackbar | null;

  @Getter("getExpiredTokenDialog", { namespace: "AppModule" })
  public getExpiredTokenDialog!: boolean;

  @Action("setExpiredTokenDialog", { namespace: "AppModule" })
	public setExpiredTokenDialog!: Callback;
	
  public snackbar = false;
  // public dialog = false;

  /*
		BLOCKER RELATED METHODS.
	*/
  @Getter("getBlockerData", { namespace: "AppModule" })
  public BlockerData: BlockerConfig;

  public ShowMyBlocker: boolean = false;

  @Watch("BlockerData")
  public watchBlockerData() {
    this.ShowMyBlocker = this.BlockerData.Show;
  }

  /*
		END: BLOCKER RELATED METHODS.
	*/

  /*
		DIALOG RELATED METHODS.
	*/
  @Getter("getDialogData", { namespace: "AppModule" })
  public DialogData: DialogConfig;

  public ShowMyDialog: boolean = false;

  @Watch("DialogData")
  public watchDialogData() {
    this.ShowMyDialog = true;
  }

  public DialogOkCallback(): void {
    this.DialogCallback(true);
  }

  public DialogCancelCallback(): void {
    this.DialogCallback(false);
  }

  public DialogCallback(value: boolean): void {
    if (this.DialogData.Callback) this.DialogData.Callback(value);
    this.ShowMyDialog = false;
  }

  /*
		END: DIALOG RELATED METHODS.
	*/

  @Watch("snackbarData")
  public setSnackbar() {
    this.snackbar = true;
  }

  @Watch("getExpiredTokenDialog")
  public setDialog() {
		if (this.getExpiredTokenDialog){
			this.UI__.QuickAlert(
				"Session Expired", 
				"Your Session has Expired.<br>Please Login in the next screen.", 
			()=>{
				this.goToLogin();
			});
		}
    // this.dialog = this.getExpiredTokenDialog;
  }

  goToLogin(): void {
    this.setExpiredTokenDialog(false);
    this.$router.push("/login");
  }
}
